import React, { Component } from 'react';
import '../css/App.css';
import '../css/fonts.css';
import '../css/addlightness.css';


export class GFL extends Component {
  constructor(props) {
    super(props)

    this.state = {
      //showDescription: false,
      showDescription: true,
    }

    this.hovered = this.hovered.bind(this)
    this.unHovered = this.unHovered.bind(this)

    this.renderAppDescriptionBox = this.renderAppDescriptionBox.bind(this)
  }


  hovered(elem) {
    console.log("GFL hovered()")
    this.setState({ showDescription: true })
  }

  unHovered(elem) {
    this.setState({ showDescription: false })
  }

  renderAppDescriptionBox() {
    //console.log("renderAppDescriptionBox()")
    const description = "Mobile video game in progress. LibGDX stack. American football inspired by the old school. Multiplayer on the way !"
    return (
      <div className='idea-description'>
        { description }
      </div>
    )
  }


  render() {

    return (
      <div className="idea-container">
        <div className='idea-row'>
          <div className='idea-row-item'>
            <div className="idea-box">
              <a href="https://play.google.com/store/apps/details?id=superfusion.gfl">
                GFL on Play Store
              </a>
            </div>
          </div>
          <div className='idea-row-item'>
            <div className="tool-description-container">
              { this.state.showDescription
                ? this.renderAppDescriptionBox()
                : null
              }
            </div>
            </div>
        </div>
      </div>
    )
  }
}
